// services/push-notifications.js
import { api } from '../api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeUser() {
  // 1. Check for service worker and push manager support
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push messaging is not supported');
    return;
  }

  // 2. Request permission from the user
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Permission not granted for Notification');
  }

  // 3. Get the service worker registration
  const registration = await navigator.serviceWorker.ready;

  // 4. Get the public VAPID key from your server
  // (You'll need to create this backend endpoint)
  const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/push/vapid-public-key');
  const { publicKey } = await response.json();
  const applicationServerKey = urlBase64ToUint8Array(publicKey);

  // 5. Subscribe the user
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: applicationServerKey
  });

  // 6. Send the subscription to your backend
  try {
  await api.savePushSubscription(subscription);
  console.log('Push subscription saved successfully.');
  } catch (error) {
    console.error('Failed to save push subscription:', error);
  }
}